import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import { SURVEY_QUESTION_TYPES } from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string,
  type: PropTypes.oneOf(SURVEY_QUESTION_TYPES),
  question: PropTypes.string,
  hint: PropTypes.string,
  image: PropTypes.shape(ImageProp.propType),
  evaluationMax: PropTypes.number,
  choices: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    option: PropTypes.string,
  })),
  startDate: PropTypes.number,
  answer: PropTypes.string,
};

export default { propType };
